// Hooks
import useTranslate from "@/hooks/useTranslate/useTranslate";

// Types
import type { I_UseValidate_Return } from "../index";

/** Функция-валидатор для поля "Date" */
export default function humanDateValidator(value: string): I_UseValidate_Return {
    if (!value) {
        return {
            status: false,
            message: useTranslate("tiw__validation__date_required"),
        };
    }

    if (!/^\d{2}\.\d{2}\.\d{4}$/.test(value)) {
        console.log("human-date: regexp");

        return {
            status: false,
            message: useTranslate("tiw__validation__date_incorrect"),
        };
    }

    return {
        status: true,
        message: useTranslate("tiw__validation__success"),
    };
}
